var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 16.8954 0.89544 16 2 16C3.10456 16 4 16.8954 4 18V22C4 23.1046 3.10456 24 2 24C0.89544 24 0 23.1046 0 22V18Z",
    fill: "#ACACAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8C8.8954 8 8 8.8954 8 10V22C8 23.1046 8.8954 24 10 24C11.1046 24 12 23.1046 12 22V10C12 8.8954 11.1046 8 10 8Z",
    fill: "#ACACAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C16 0.89544 16.8954 0 18 0C19.1046 0 20 0.89544 20 2V22C20 23.1046 19.1046 24 18 24C16.8954 24 16 23.1046 16 22V2Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnection);
export default __webpack_public_path__ + "static/media/icon_connection.ae268818780226c31488ffc54dbf8d57.svg";
export { ForwardRef as ReactComponent };